module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Tabla de Contenido")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Título")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Derechos de Autor")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c003"
    }
  }, [_vm._v("OBRAS MAESTRAS DE MALICIA 6")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c004"
    }
  }, [_vm._v("NOTA DEL EDITOR | Esta es una obra de ficción. Los nombres, personajes, lugares, e incidentes son el producto de la imaginación del autor o se utilizan ficticiamente, y cualquier parecido con personas reales, vivas o muertas, establecimientos empresariales, eventos, o locales es totalmente coincidente. | El editor no tiene ningún control ni asume ninguna responsabilidad por el autor o por sitios web de terceros o su contenido.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c005"
    }
  }, [_vm._v("MALICIA METÓDICA | LIBRO 26")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MALICIA MALÉVOLA | LIBRO 27")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MALICIA MILITAR | LIBRO 28")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MALICIA MAQUIAVÉLICA | LIBRO 29")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MALICIA MALÉFICA | LIBRO 30")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("-Fin-")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0